if (!customElements.get('dl-page-sticky-header-y')) {
  class DlPageStickyHeaderY extends HTMLElement {
    constructor() {
      super();
      this.items = [];
      this.activeItem = null;
      this.clicking = false;
      this.currentActiveIndex = -1;
      this.raf = null;
      this.scrolling = null;
      this.onScroll = this.scroll.bind(this);
    }

    connectedCallback() {
      this.headerType = this.dataset.headerType || 'default';
      this.bar = this.querySelector('.dl-page-sticky-header-y');
      this.nav = this.querySelector('.dl-page-sticky-header-y__nav');
      this.items = Array.from(this.querySelectorAll('.dl-page-sticky-header-y__item'));
      this.bindEvents();
      this.scroll();
      this.checkUrlParams();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      if (this.raf) cancelAnimationFrame(this.raf);
      if (this.scrolling) clearTimeout(this.scrolling);
    }

    checkUrlParams() {
      const urlParams = new URLSearchParams(window.location.search);
      const scrollTo = urlParams.get('scroll_to');
      if (!scrollTo) return;

      this.removeScrollParam();
      const targetItem = this.items.find((item) => item.dataset.dlValue === scrollTo);
      this.move(scrollTo);
      if (targetItem) this.setActive(targetItem);
    }

    removeScrollParam() {
      const url = new URL(window.location.href);
      url.searchParams.delete('scroll_to');
      window.history.replaceState({}, '', url);
    }

    bindEvents() {
      this.items.forEach((item) => {
        item.addEventListener('click', () => this.clickItem(item));
      });
      window.addEventListener('scroll', this.onScroll, { passive: true });
    }

    clickItem(item) {
      this.clicking = true;
      this.setActive(item);
      this.move(item.dataset.dlValue);
      if (typeof DLPixelH !== 'undefined') {
        DLPixelH.capture('page_sticky_header_item_click', {
          item_name: item.dataset.dlValue,
        });
      }
    }

    show() {
      this.classList.add('dl-show');
    }

    hide() {
      this.classList.remove('dl-show');
    }

    setActive(item) {
      if (!item || this.activeItem === item) return;

      this.items.forEach((_item) => {
        _item.classList.toggle('dl-active', _item === item);
      });
      this.activeItem = item;
      this.itemToCenter(item);
    }

    clearActive() {
      this.items.forEach((item) => item.classList.remove('dl-active'));
      this.activeItem = null;
      this.currentActiveIndex = -1;
    }

    active(item) {
      if (this.clicking) return;
      this.setActive(item);
    }

    barHeight() {
      return this.bar ? this.bar.offsetHeight : 0;
    }

    move(value) {
      const target = document.querySelector(`.dl-page-position-item-h[data-dl-value="${value}"]`);
      if (!target) return;

      const targetPosition = target.getBoundingClientRect().top + window.scrollY - this.barHeight() + 2;
      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth',
      });
    }

    handleItemActive() {
      const targets = document.querySelectorAll('.dl-page-position-item-h');
      if (!targets.length || !this.items.length) return;

      const offset = this.barHeight();
      let nextIndex = -1;
      const targetCount = Math.min(targets.length, this.items.length);

      for (let i = 0; i < targetCount; i += 1) {
        const top = targets[i].getBoundingClientRect().top - offset;
        if (top <= 0) nextIndex = i;
        else break;
      }

      if (nextIndex < 0) {
        this.clearActive();
        return;
      }

      this.currentActiveIndex = nextIndex;
      this.active(this.items[nextIndex]);
    }

    isInScrollyStage() {
      const scrolly = document.querySelector('dl-page-scrolly-luma-y');
      if (!scrolly) return false;

      const rect = scrolly.getBoundingClientRect();
      return rect.top <= this.barHeight() && rect.bottom > window.innerHeight;
    }

    handleVisibility() {
      const inScrolly = this.isInScrollyStage();
      this.classList.toggle('dl-scrolly-hide', inScrolly);
      if (inScrolly) return;

      if (this.headerType === 'fixed') {
        this.show();
        return;
      }

      const firstTarget = document.querySelector('.dl-page-position-item-h');
      if (!firstTarget) return;

      const firstTargetPosition = firstTarget.getBoundingClientRect().top + window.scrollY;
      if (window.scrollY + 100 >= firstTargetPosition - this.barHeight()) {
        this.show();
      } else {
        this.hide();
      }
    }

    itemToCenter(activeItem) {
      if (!this.nav || !activeItem) return;
      const containerWidth = this.nav.offsetWidth;
      const itemWidth = activeItem.offsetWidth;
      const itemOffsetLeft = activeItem.offsetLeft;
      const scrollToPosition = itemOffsetLeft - containerWidth / 2 + itemWidth / 2;
      this.nav.scrollTo({
        left: Math.max(0, scrollToPosition),
        behavior: 'smooth',
      });
    }

    scroll() {
      if (!this.raf) {
        this.raf = window.requestAnimationFrame(() => {
          this.raf = null;
          this.handleItemActive();
          this.handleVisibility();
        });
      }

      if (this.scrolling) clearTimeout(this.scrolling);
      this.scrolling = setTimeout(() => {
        if (this.clicking) {
          this.clicking = false;
          this.handleItemActive();
        }
      }, 100);
    }
  }

  customElements.define('dl-page-sticky-header-y', DlPageStickyHeaderY);
}
